// extracted by mini-css-extract-plugin
export var active = "_jp-2";
export var recordingDot = "_jp-1";
export var recordingIndicator = "_jp-0";